import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "partners _container" }
const _hoisted_2 = {
  key: 0,
  class: "partners__title text-bold-title"
}
const _hoisted_3 = {
  key: 1,
  class: "partners__loader"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"partners__item--text-wrapper\"><div class=\"partners__item--text\"><div class=\"partners__item--title text-bold skeleton\" style=\"width:159px;height:20px;flex:unset;margin-bottom:10px;\"></div><div class=\"partners__item--subtitle skeleton\" style=\"width:140px;height:20px;flex:unset;margin-bottom:10px;\"></div><div class=\"skeleton\" style=\"width:150px;height:20px;\"></div></div></div><div class=\"partners__item--img skeleton\"></div>", 2)
const _hoisted_6 = [
  _hoisted_4
]
const _hoisted_7 = {
  key: 2,
  class: "partners__items"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "partners__item--text-wrapper" }
const _hoisted_10 = { class: "partners__item--text" }
const _hoisted_11 = { class: "partners__item--title text-bold" }
const _hoisted_12 = { class: "partners__item--subtitle" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["onLoad", "src"]
const _hoisted_19 = ["height"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "partners__all" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "partners__all--text" }, "Смотреть все привилегии"),
  /*#__PURE__*/_createElementVNode("div", { class: "partners__all--icon" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      width: "17",
      height: "14",
      viewBox: "0 0 17 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M9.29289 0.292893C9.68342 -0.0976312 10.3166 -0.0976312 10.7071 0.292893L16.7071 6.29289C16.7559 6.34171 16.7986 6.39431 16.8352 6.44977C17.0915 6.83792 17.0488 7.3654 16.7071 7.70711L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071C8.90237 13.3166 8.90237 12.6834 9.29289 12.2929L13.5858 8H0.882353C0.395043 8 0 7.55228 0 7C0 6.44772 0.395043 6 0.882353 6H13.5858L9.29289 1.70711C8.90237 1.31658 8.90237 0.683417 9.29289 0.292893Z",
        fill: "#E11B11"
      })
    ])
  ])
], -1)

import { computed, ref, watchEffect } from 'vue'
import store from '@/store'
import { ContentLoader } from 'vue-content-loader'


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnersPrivil',
  props: {
  showTitle: Boolean,
  showLink: Boolean,
  partnerCards: Array,
  allPrivil: {
    type: Boolean,
    default: false,
  },
},
  emits: ['partners-click-card', 'loader-finished'],
  setup(__props, { emit }) {

const props = __props;



const imgArr = ref([])

// const isCardBusy = ref(false)
watchEffect(async () => {
  let test: any = props.partnerCards
  let arr: any = []
  imgArr.value = []
  console.log('WATCH EFFECT START')
  for (const i of test) {
    await fetch(i.getCardImg(), { mode: 'no-cors' }).then(() =>
      arr.push(i.getCardImg())
    )
    // await new Promise((resolve) => setTimeout(resolve, 100))
  }
  console.log('WATCH EFFECT END', arr)
  imgArr.value = arr
})
const isCardBusy = computed(() => store.getters.isCardBusy)

// watch(cardBusy, (value) => {
//   if (value) {
//     isCardBusy.value = true
//     emit('loader-finished', false)
//     setTimeout(() => {
//       isCardBusy.value = false
//       emit('loader-finished', true)
//     }, 500)
//   }
// })

const setCard = (item) => {
  // Устанавливаем карточку
  store
    .dispatch('getCardItem', { filter: { cardId: item.getCardId() } })
    .then(() => {
      // Показываем модальное окно
      emit('partners-click-card')
    })
}

const imgLoaded = (el, id) => {
  if (el) {
    let card: any = document.querySelectorAll(`.partners__item-${id}`)
    card.forEach((card) => {
      card.style.display = 'block'
    })
    // el.path[1].style.display = 'block'
    let loader = document.querySelectorAll(`.partners__loader--card-${id}`)
    loader.forEach((el) => (el.style.display = 'none'))

    // el.path[1].style.display = 'block'
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.showTitle && (_unref(isCardBusy) || __props.partnerCards?.length > 0))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Привилегии от партнеров "))
      : _createCommentVNode("", true),
    (_unref(isCardBusy))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "partners__loader--card"
            }, [
              (_openBlock(), _createElementBlock("div", {
                class: "partners__item",
                style: _normalizeStyle(__props.allPrivil ? { height: '191px' } : { height: '180px' }),
                key: _ctx.partnerCardItem
              }, _hoisted_6, 4))
            ])
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (!_unref(isCardBusy) && __props.partnerCards?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.partnerCards, (partnerCardItem, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "partners__item",
              style: _normalizeStyle(__props.allPrivil ? { height: '191px' } : { height: '180px' }),
              key: partnerCardItem,
              onClick: ($event: any) => (setCard(partnerCardItem))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(partnerCardItem.getCardName()), 1),
                  _createElementVNode("div", _hoisted_12, [
                    (partnerCardItem.getTypeName() == 'Социальный пакет')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createElementVNode("span", null, _toDisplayString(partnerCardItem.getTypeName()), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          (partnerCardItem.getCityName() != 'Вся Россия')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(partnerCardItem.getCityName()), 1))
                            : _createCommentVNode("", true),
                          (partnerCardItem.getSbeName() != 'Все СБЕ')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                (partnerCardItem.getCityName() != 'Вся Россия')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", "))
                                  : _createCommentVNode("", true),
                                _createTextVNode(_toDisplayString(partnerCardItem.getSbeName()), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(["partners__item--img", 'partners__item-' + idx])
              }, [
                _createElementVNode("img", {
                  onLoad: (el) => imgLoaded(el, idx),
                  class: "partners__item--image",
                  src: imgArr.value[idx],
                  alt: ""
                }, null, 40, _hoisted_18)
              ], 2), [
                [_vShow, false && imgArr.value[idx]]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass('partners__loader--card-' + idx),
                style: {"flex":"0 1 140px"}
              }, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 140 190",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#ecebeb"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("rect", {
                      x: "5",
                      y: "5",
                      rx: "16",
                      ry: "16",
                      width: "130",
                      height: __props.allPrivil ? 181 : 170
                    }, null, 8, _hoisted_19)
                  ]),
                  _: 1
                })
              ], 2), [
                [_vShow, true]
              ])
            ], 12, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_router_link, {
      class: "partners__link",
      to: "/all"
    }, {
      default: _withCtx(() => [
        _hoisted_20
      ]),
      _: 1
    }, 512), [
      [_vShow, __props.showLink]
    ])
  ]))
}
}

})